import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchLatestResultByTestCase = async (testCaseId) => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "latestRecordingStatus",
    companyid: user.companyid,
    testcaseid: testCaseId,
  });

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params}`);
  const data = response.data;

  if (data?.result) {
    data.result = {
      ...data.result,
      testcasename: data.result.testcase,
      logFile: data.result.logfile,
    };
  }

  return data;
};

const useLatestResultByTestCaseQuery = (testCaseId, options = {}) => {
  return useQuery({
    queryKey: ["latestResultByTestCase", testCaseId],
    queryFn: () => fetchLatestResultByTestCase(testCaseId),
    enabled: options.enabled && !!testCaseId,
    retry: 2,
    cacheTime: 0,
    staleTime: 0,
  });
};

export default useLatestResultByTestCaseQuery;
